import { useEffect, useState } from "react";
import Address from "../../components/Address";
import { AdminMenuBar } from "../../components/admin/AdminMenuBar";
import { AdminComplement } from "../../components/admin/customer_support/AdminComplement";
import { AdminPostForEdit } from "../../components/admin/customer_support/AdminPostForEdit";
import { checkSession } from "../../services/Admin";
import { editPost, getEntireDetail, getIsSecret } from "../../services/CustomerAPI";
import "../ContentFrame.css";
import "../Main.css";

export const AdminAnnouncementComplementForm = () => {
    const [isSecret, setIsSecret] = useState(false); // 비밀글인지
    const [complement, setComplement] = useState([]);
    const [componentNumber, setComponentNumber] = useState(0);
    const [id, setId] = useState();
    const [page, setPage] = useState();

    useEffect(() => {
        checkSession();

        let splitedPath = window.location.href.split("/");
        let lastPath = splitedPath[splitedPath.length - 1];
        setId(lastPath.split("-")[1]);
        setPage(lastPath.split("-")[0]);
    }, []);

    useEffect(() => {
        id &&
            getEntireDetail(id).then((response) => {
                setComplement(response.data);
            });
        id &&
            getIsSecret(id).then((response) => {
                setIsSecret(response.data.secret);
            });
    }, [id]);

    const editSales = (formData, file) => {
        editPost(id, formData, file, "IRL");
    };

    const goList = () => {
        window.location.href = `/admin/announcement?page=${page}`;
    };

    return (
        <div>
            <AdminMenuBar selected_page={9} />
            <div className="w-full h-full bg-white">
                <div className="common_frame_container">
                    <div className="common_content_container">
                        <div style={{ width: "100%", height: "100px" }}></div>
                        <span className="page_title">채용정보</span>
                        {
                            {
                                0: (
                                    <AdminComplement
                                        complement={complement}
                                        id={id}
                                        setComponentNumber={setComponentNumber}
                                        goList={goList}
                                    />
                                ),
                                1: (
                                    <AdminPostForEdit
                                        complement={complement}
                                        id={id}
                                        editSales={editSales}
                                        goList={goList}
                                    />
                                ),
                            }[componentNumber]
                        }
                        <div style={{ width: "100%", height: "100px" }}></div>
                    </div>
                </div>
            </div>
            <Address />
        </div>
    );
};
